export default __webpack_public_path__ + "static/media/screenshot1.f3a07f6c.jpg";